import { saveDiscoveryChildDiscoveryRules as saveDiscoveryChildDiscoveryRulesPM } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {}

export const saveDiscoveryChildDiscoveryRules = ({
    eventEmitter,
}: Props) => {
    saveDiscoveryChildDiscoveryRulesPM();
};
